import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=1d3f6470&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d3f6470')) {
      api.createRecord('1d3f6470', component.options)
    } else {
      api.reload('1d3f6470', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=1d3f6470&", function () {
      api.rerender('1d3f6470', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TnIkpV7BZqlf/JS/cancellationPolicy.vue"
export default component.exports